import { Locale, type LocalizedString } from "../Locale.js";
import { SubscriptionKind } from "../SubscriptionKind.js";

export const subscriptionKindNameMap: Record<SubscriptionKind, LocalizedString> = {
	[SubscriptionKind.Gift]: { [Locale.cs]: "Darované předplatné", [Locale.en]: "Gift subscription" },
	[SubscriptionKind.Recurring]: { [Locale.cs]: "Měsíční předplatné", [Locale.en]: "Monthly subscription" },
};
